import { useTheme } from "./hooks/useTheme";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Leadership } from "./components/Leadership";
import { Portfolio } from "./components/Portfolio";
import { Education } from "./components/Education";
import { Contacts } from "./components/Contacts";
import { Footer } from "./components/Footer";
import { BackToTop } from "./components/BackToTop";

export default function App() {
  const { theme, toggle } = useTheme();

  return (
    <>
      <Nav theme={theme} onToggleTheme={toggle} />
      <main>
        <Hero />
        <Leadership />
        <Portfolio />
        <Education />
        <Contacts />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}
